
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic01On as ObiHydraulic01OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-01-on.js';
 
 
 

 
 export const ObiHydraulic01On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-01-on',
   elementClass: ObiHydraulic01OnElement,
   events: {
     
   }
  });
 
 